/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import type {
  Error,
  FinancialPlan,
  FinancialPlanInput,
  PlanEvent,
  PlanEventInput,
  RetirementProfile,
  RetirementProfileInput,
  SuccessionProfile,
  SuccessionProfileInput,
} from '.././model';

import { customInstance } from '../../axios-instance';

/**
 * @summary Get all financial plans
 */
export const getAllPlans = (signal?: AbortSignal) => {
  return customInstance<FinancialPlan[]>({ url: `/api/plans`, method: 'GET', signal });
};

export const getGetAllPlansQueryKey = () => {
  return [`/api/plans`] as const;
};

export const getGetAllPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPlans>>,
  TError = Error,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPlans>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllPlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPlans>>> = ({ signal }) =>
    getAllPlans(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPlans>>>;
export type GetAllPlansQueryError = Error;

export function useGetAllPlans<TData = Awaited<ReturnType<typeof getAllPlans>>, TError = Error>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPlans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPlans>>,
          TError,
          Awaited<ReturnType<typeof getAllPlans>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllPlans<TData = Awaited<ReturnType<typeof getAllPlans>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPlans>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPlans>>,
          TError,
          Awaited<ReturnType<typeof getAllPlans>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllPlans<TData = Awaited<ReturnType<typeof getAllPlans>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPlans>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all financial plans
 */

export function useGetAllPlans<TData = Awaited<ReturnType<typeof getAllPlans>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPlans>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllPlansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a financial plan
 */
export const createPlan = (financialPlanInput: FinancialPlanInput, signal?: AbortSignal) => {
  return customInstance<FinancialPlan>({
    url: `/api/plans`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: financialPlanInput,
    signal,
  });
};

export const getCreatePlanMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlan>>,
    TError,
    { data: FinancialPlanInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlan>>,
  TError,
  { data: FinancialPlanInput },
  TContext
> => {
  const mutationKey = ['createPlan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlan>>,
    { data: FinancialPlanInput }
  > = (props) => {
    const { data } = props ?? {};

    return createPlan(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof createPlan>>>;
export type CreatePlanMutationBody = FinancialPlanInput;
export type CreatePlanMutationError = Error;

/**
 * @summary Create a financial plan
 */
export const useCreatePlan = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPlan>>,
      TError,
      { data: FinancialPlanInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPlan>>,
  TError,
  { data: FinancialPlanInput },
  TContext
> => {
  const mutationOptions = getCreatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get a financial plan
 */
export const getPlan = (planId: string, signal?: AbortSignal) => {
  return customInstance<FinancialPlan>({ url: `/api/plans/${planId}`, method: 'GET', signal });
};

export const getGetPlanQueryKey = (planId: string) => {
  return [`/api/plans/${planId}`] as const;
};

export const getGetPlanQueryOptions = <TData = Awaited<ReturnType<typeof getPlan>>, TError = Error>(
  planId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanQueryKey(planId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlan>>> = ({ signal }) =>
    getPlan(planId, signal);

  return { queryKey, queryFn, enabled: !!planId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>;
export type GetPlanQueryError = Error;

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = Error>(
  planId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = Error>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = Error>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a financial plan
 */

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = Error>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlanQueryOptions(planId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a financial plan
 */
export const updatePlan = (planId: string, financialPlanInput: FinancialPlanInput) => {
  return customInstance<FinancialPlan>({
    url: `/api/plans/${planId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: financialPlanInput,
  });
};

export const getUpdatePlanMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlan>>,
    TError,
    { planId: string; data: FinancialPlanInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlan>>,
  TError,
  { planId: string; data: FinancialPlanInput },
  TContext
> => {
  const mutationKey = ['updatePlan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlan>>,
    { planId: string; data: FinancialPlanInput }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updatePlan(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlan>>>;
export type UpdatePlanMutationBody = FinancialPlanInput;
export type UpdatePlanMutationError = Error;

/**
 * @summary Update a financial plan
 */
export const useUpdatePlan = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlan>>,
      TError,
      { planId: string; data: FinancialPlanInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlan>>,
  TError,
  { planId: string; data: FinancialPlanInput },
  TContext
> => {
  const mutationOptions = getUpdatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a financial plan
 */
export const deletePlan = (planId: string) => {
  return customInstance<void>({ url: `/api/plans/${planId}`, method: 'DELETE' });
};

export const getDeletePlanMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlan>>,
    TError,
    { planId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlan>>,
  TError,
  { planId: string },
  TContext
> => {
  const mutationKey = ['deletePlan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlan>>, { planId: string }> = (
    props
  ) => {
    const { planId } = props ?? {};

    return deletePlan(planId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlanMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlan>>>;

export type DeletePlanMutationError = Error;

/**
 * @summary Delete a financial plan
 */
export const useDeletePlan = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePlan>>,
      TError,
      { planId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deletePlan>>,
  TError,
  { planId: string },
  TContext
> => {
  const mutationOptions = getDeletePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List plan events
 */
export const getPlanEvents = (planId: string, signal?: AbortSignal) => {
  return customInstance<PlanEvent[]>({ url: `/api/plans/${planId}/events`, method: 'GET', signal });
};

export const getGetPlanEventsQueryKey = (planId: string) => {
  return [`/api/plans/${planId}/events`] as const;
};

export const getGetPlanEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanEvents>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanEvents>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanEventsQueryKey(planId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanEvents>>> = ({ signal }) =>
    getPlanEvents(planId, signal);

  return { queryKey, queryFn, enabled: !!planId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanEvents>>>;
export type GetPlanEventsQueryError = unknown;

export function useGetPlanEvents<
  TData = Awaited<ReturnType<typeof getPlanEvents>>,
  TError = unknown,
>(
  planId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanEvents>>,
          TError,
          Awaited<ReturnType<typeof getPlanEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanEvents<
  TData = Awaited<ReturnType<typeof getPlanEvents>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanEvents>>,
          TError,
          Awaited<ReturnType<typeof getPlanEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanEvents<
  TData = Awaited<ReturnType<typeof getPlanEvents>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List plan events
 */

export function useGetPlanEvents<
  TData = Awaited<ReturnType<typeof getPlanEvents>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlanEventsQueryOptions(planId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a plan event
 */
export const createPlanEvent = (
  planId: string,
  planEventInput: PlanEventInput,
  signal?: AbortSignal
) => {
  return customInstance<PlanEvent>({
    url: `/api/plans/${planId}/events`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: planEventInput,
    signal,
  });
};

export const getCreatePlanEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlanEvent>>,
    TError,
    { planId: string; data: PlanEventInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlanEvent>>,
  TError,
  { planId: string; data: PlanEventInput },
  TContext
> => {
  const mutationKey = ['createPlanEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlanEvent>>,
    { planId: string; data: PlanEventInput }
  > = (props) => {
    const { planId, data } = props ?? {};

    return createPlanEvent(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlanEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlanEvent>>
>;
export type CreatePlanEventMutationBody = PlanEventInput;
export type CreatePlanEventMutationError = unknown;

/**
 * @summary Create a plan event
 */
export const useCreatePlanEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPlanEvent>>,
      TError,
      { planId: string; data: PlanEventInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPlanEvent>>,
  TError,
  { planId: string; data: PlanEventInput },
  TContext
> => {
  const mutationOptions = getCreatePlanEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update a plan event
 */
export const updatePlanEvent = (
  planId: string,
  eventId: string,
  planEventInput: PlanEventInput
) => {
  return customInstance<PlanEvent>({
    url: `/api/plans/${planId}/events/${eventId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: planEventInput,
  });
};

export const getUpdatePlanEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanEvent>>,
    TError,
    { planId: string; eventId: string; data: PlanEventInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanEvent>>,
  TError,
  { planId: string; eventId: string; data: PlanEventInput },
  TContext
> => {
  const mutationKey = ['updatePlanEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanEvent>>,
    { planId: string; eventId: string; data: PlanEventInput }
  > = (props) => {
    const { planId, eventId, data } = props ?? {};

    return updatePlanEvent(planId, eventId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanEvent>>
>;
export type UpdatePlanEventMutationBody = PlanEventInput;
export type UpdatePlanEventMutationError = unknown;

/**
 * @summary Update a plan event
 */
export const useUpdatePlanEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlanEvent>>,
      TError,
      { planId: string; eventId: string; data: PlanEventInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanEvent>>,
  TError,
  { planId: string; eventId: string; data: PlanEventInput },
  TContext
> => {
  const mutationOptions = getUpdatePlanEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a plan event
 */
export const deletePlanEvent = (planId: string, eventId: string) => {
  return customInstance<void>({ url: `/api/plans/${planId}/events/${eventId}`, method: 'DELETE' });
};

export const getDeletePlanEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanEvent>>,
    TError,
    { planId: string; eventId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlanEvent>>,
  TError,
  { planId: string; eventId: string },
  TContext
> => {
  const mutationKey = ['deletePlanEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlanEvent>>,
    { planId: string; eventId: string }
  > = (props) => {
    const { planId, eventId } = props ?? {};

    return deletePlanEvent(planId, eventId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlanEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlanEvent>>
>;

export type DeletePlanEventMutationError = unknown;

/**
 * @summary Delete a plan event
 */
export const useDeletePlanEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePlanEvent>>,
      TError,
      { planId: string; eventId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deletePlanEvent>>,
  TError,
  { planId: string; eventId: string },
  TContext
> => {
  const mutationOptions = getDeletePlanEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get retirement profile for a plan
 */
export const getPlanRetirement = (planId: string, signal?: AbortSignal) => {
  return customInstance<RetirementProfile>({
    url: `/api/plans/${planId}/retirement`,
    method: 'GET',
    signal,
  });
};

export const getGetPlanRetirementQueryKey = (planId: string) => {
  return [`/api/plans/${planId}/retirement`] as const;
};

export const getGetPlanRetirementQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanRetirement>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanRetirement>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanRetirementQueryKey(planId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanRetirement>>> = ({ signal }) =>
    getPlanRetirement(planId, signal);

  return { queryKey, queryFn, enabled: !!planId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanRetirement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanRetirementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanRetirement>>
>;
export type GetPlanRetirementQueryError = unknown;

export function useGetPlanRetirement<
  TData = Awaited<ReturnType<typeof getPlanRetirement>>,
  TError = unknown,
>(
  planId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanRetirement>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanRetirement>>,
          TError,
          Awaited<ReturnType<typeof getPlanRetirement>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanRetirement<
  TData = Awaited<ReturnType<typeof getPlanRetirement>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanRetirement>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanRetirement>>,
          TError,
          Awaited<ReturnType<typeof getPlanRetirement>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanRetirement<
  TData = Awaited<ReturnType<typeof getPlanRetirement>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanRetirement>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get retirement profile for a plan
 */

export function useGetPlanRetirement<
  TData = Awaited<ReturnType<typeof getPlanRetirement>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanRetirement>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlanRetirementQueryOptions(planId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update retirement profile for a plan
 */
export const updatePlanRetirement = (
  planId: string,
  retirementProfileInput: RetirementProfileInput
) => {
  return customInstance<RetirementProfile>({
    url: `/api/plans/${planId}/retirement`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: retirementProfileInput,
  });
};

export const getUpdatePlanRetirementMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanRetirement>>,
    TError,
    { planId: string; data: RetirementProfileInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanRetirement>>,
  TError,
  { planId: string; data: RetirementProfileInput },
  TContext
> => {
  const mutationKey = ['updatePlanRetirement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanRetirement>>,
    { planId: string; data: RetirementProfileInput }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updatePlanRetirement(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanRetirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanRetirement>>
>;
export type UpdatePlanRetirementMutationBody = RetirementProfileInput;
export type UpdatePlanRetirementMutationError = unknown;

/**
 * @summary Update retirement profile for a plan
 */
export const useUpdatePlanRetirement = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlanRetirement>>,
      TError,
      { planId: string; data: RetirementProfileInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanRetirement>>,
  TError,
  { planId: string; data: RetirementProfileInput },
  TContext
> => {
  const mutationOptions = getUpdatePlanRetirementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get succession profile for a plan
 */
export const getPlanSuccession = (planId: string, signal?: AbortSignal) => {
  return customInstance<SuccessionProfile>({
    url: `/api/plans/${planId}/succession`,
    method: 'GET',
    signal,
  });
};

export const getGetPlanSuccessionQueryKey = (planId: string) => {
  return [`/api/plans/${planId}/succession`] as const;
};

export const getGetPlanSuccessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanSuccession>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSuccession>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanSuccessionQueryKey(planId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanSuccession>>> = ({ signal }) =>
    getPlanSuccession(planId, signal);

  return { queryKey, queryFn, enabled: !!planId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanSuccession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanSuccessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanSuccession>>
>;
export type GetPlanSuccessionQueryError = unknown;

export function useGetPlanSuccession<
  TData = Awaited<ReturnType<typeof getPlanSuccession>>,
  TError = unknown,
>(
  planId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSuccession>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanSuccession>>,
          TError,
          Awaited<ReturnType<typeof getPlanSuccession>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanSuccession<
  TData = Awaited<ReturnType<typeof getPlanSuccession>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSuccession>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanSuccession>>,
          TError,
          Awaited<ReturnType<typeof getPlanSuccession>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlanSuccession<
  TData = Awaited<ReturnType<typeof getPlanSuccession>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSuccession>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get succession profile for a plan
 */

export function useGetPlanSuccession<
  TData = Awaited<ReturnType<typeof getPlanSuccession>>,
  TError = unknown,
>(
  planId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSuccession>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlanSuccessionQueryOptions(planId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update succession profile for a plan
 */
export const updatePlanSuccession = (
  planId: string,
  successionProfileInput: SuccessionProfileInput
) => {
  return customInstance<SuccessionProfile>({
    url: `/api/plans/${planId}/succession`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: successionProfileInput,
  });
};

export const getUpdatePlanSuccessionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanSuccession>>,
    TError,
    { planId: string; data: SuccessionProfileInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanSuccession>>,
  TError,
  { planId: string; data: SuccessionProfileInput },
  TContext
> => {
  const mutationKey = ['updatePlanSuccession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanSuccession>>,
    { planId: string; data: SuccessionProfileInput }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updatePlanSuccession(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanSuccessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanSuccession>>
>;
export type UpdatePlanSuccessionMutationBody = SuccessionProfileInput;
export type UpdatePlanSuccessionMutationError = unknown;

/**
 * @summary Update succession profile for a plan
 */
export const useUpdatePlanSuccession = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlanSuccession>>,
      TError,
      { planId: string; data: SuccessionProfileInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanSuccession>>,
  TError,
  { planId: string; data: SuccessionProfileInput },
  TContext
> => {
  const mutationOptions = getUpdatePlanSuccessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
